import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DataSharingService } from '../services/data-sharing.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {


  isAccepted: boolean = false;
  token: string = "";
  tokenPayload;
  expirationDate;
  checkLinkExpiryFlag: boolean = true;
  invitationObj;
  msg = "";

  // clientName: string = '';
  disclaimerText: string = '';
  clientId: string = '';
  caseId: string = '';
  isLoading: boolean = true;
  id: any;
  constructor(private dataSharingSrvc: DataSharingService, private activatedRoute: ActivatedRoute, private router: Router, private jwtHelper: JwtHelperService) { }

  async ngOnInit() {
    this.isLoading = true;

    console.log('locationlocation', JSON.stringify(location));

    if (location.href.toString().includes('caseId')) {
      console.log('Found : caseId')
      const calllStr = location.href.toString().split('?')[1];
      console.log('calllStr', calllStr);
      const params = this.formulateQueryParams(calllStr);
      console.log('params', params);
      this.router.navigate(['video-calling'], { queryParams:params}); 
        //{caseId:params['caseId'],applicantName:params['applicantName'],mobileNo:params['mobileNo'],client:params['client'],clientId:params['clientId'], activityId:params['activityId'], activity:params['activity']} });
      return;

      
    }




    this.activatedRoute.queryParams.subscribe(params => {
       console.log('For Accept Terms and condition', params);



      // if (params['caseId']) {
      //   this.router.navigateByUrl("video-calling"); //+ params['caseId'] + "/" + params['applicantName'] + "/" + params['mobileNo'] + "/" + params['client'] + "/" + params['clientId'] + "/" + params['activityId'] + "/" + params['activity']
      //   this.router.navigate(['video-calling'], { queryParams: {caseId:params['caseId'],applicantName:params['applicantName'],mobileNo:params['mobileNo'],client:params['client'],clientId:params['clientId'], activityId:params['activityId'], activity:params['activity']} });
      //   return;
      // }
      // this.token = params['token'];
      this.id = params['a'];
      this.dataSharingSrvc["autoId"] = params['a'];
      // // this.clientName = params['client'] ?? '';
      // this.clientId = params['clientid'] ?? '';
      // this.caseId = params['caseid'] ?? '';
    });
    // this.token = this.activatedRoute.snapshot.params['token'];
    // // this.clientName = this.activatedRoute.snapshot.params['client'] ?? '';
    // this.clientId = this.activatedRoute.snapshot.params['clientid'] ?? '';
    // this.caseId = this.activatedRoute.snapshot.params['caseid'] ?? '';
    await this.getExpiredToken();
  }

  formulateQueryParams(param:string){
    param = param.replace(/%20/g, ' ');
    const paramsArr = param.split('&');
    let retParamsObj = {};
    for (let param of paramsArr) {
      const paramKeyVal = param.split('=');
      const key = paramKeyVal[0].trim();
      const val = paramKeyVal[1].trim();
      retParamsObj[key] = val;
      
    }
    return retParamsObj;
  }

  acceptTermsAndConditions() {
    // this.dataSharingSrvc["autoId"] = this.activatedRoute.snapshot.params['id'];
    // this.router.navigateByUrl("invite/" + this.activatedRoute.snapshot.params['id']);

    this.dataSharingSrvc["autoId"] = this.id
    this.router.navigateByUrl("invite/" + this.id);
  }
  GetTokenDecoded() {
    //console.log(this.jwtHelper.decodeToken(this.token))
    this.tokenPayload = JSON.stringify(this.jwtHelper.decodeToken(this.token));
  }
  getTokenExpirationDate() {
    console.log('in token expiration date');

    this.isLoading = true;
    this.expirationDate = this.jwtHelper.getTokenExpirationDate(this.token);
    if (this.expirationDate.getTime() <= new Date().getTime()) {
      this.checkLinkExpiryFlag = true;
      this.msg = "The link has expired.";
    }
    else {
      this.getInvitationDetails();
      this.getDisclaimer();
    }
    this.isLoading = false;

  }
  isAuthenticated(): boolean {
    return !this.jwtHelper.isTokenExpired(this.token);
  }


  async getExpiredToken() {
    this.isLoading = true;
    this.dataSharingSrvc.getMethod("getExpToken/" + this.id, {})
      .subscribe(succ => {
        if (succ['errorCode'] == 0) {
          this.checkLinkExpiryFlag = false;
          this.isLoading = false;
          let resObject = succ['data'];
          this.token = resObject['linkexpiryToken'];
          this.clientId = resObject['clientId'];
          this.caseId = resObject['caseId'];
        }
      })
  }

  async getInvitationDetails() {
    this.isLoading = true;

    this.dataSharingSrvc.getMethod("getChannelDetails/" + this.id, {})
      .subscribe(
        succ => {

          if (succ['errorCode'] == 0) {
            let resObject = succ['data']['resObj'];
            // this.token = resObject['linkexpiryToken'];
            // this.clientId = resObject['clientId'];
            // this.caseId = resObject['caseId'];
            // console.log("Token: ", this.token, this.clientId, this.caseId, resObject['linkexpiryToken']);

            this.invitationObj = JSON.parse(JSON.stringify(succ['data']));
            this.GetTokenDecoded();
            console.log("Token: ", this.token, this.clientId, this.caseId);
            this.getTokenExpirationDate();
            if (this.invitationObj["callStatus"] == "C") {
              this.msg = "Using this link call has already completed.";
              this.checkLinkExpiryFlag = true;
            } else if (this.invitationObj["callStatus"] == "R") {
              this.msg = "Using this link call is in progress / completed.";
              this.checkLinkExpiryFlag = true;
            }
            else {
              this.checkLinkExpiryFlag = false;
            }
          }
          else {
            console.error(succ);
          }
          this.isLoading = false;
        },
        err => {
          console.error(err);
          this.isLoading = false;
        }
      )
  }

  getDisclaimer() {
    this.isLoading = true;
    this.dataSharingSrvc.getMethod("getDisclaimer", { caseid: this.caseId, clientid: this.clientId })
      .subscribe(
        succ => {

          if (succ['errorCode'] == 0 && succ['DisclaimerText']) {
            this.disclaimerText = succ['DisclaimerText'];
          }
          else {
            console.error(succ);
          }
          this.isLoading = false;

        },
        err => {
          this.isLoading = false;
          console.error(err);
        }
      )
  }
}
